import { render, staticRenderFns } from "./BounceReport.vue?vue&type=template&id=6b70c997&scoped=true"
import script from "./BounceReport.vue?vue&type=script&lang=js"
export * from "./BounceReport.vue?vue&type=script&lang=js"
import style0 from "./BounceReport.vue?vue&type=style&index=0&id=6b70c997&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./BounceReport.vue?vue&type=style&index=1&id=6b70c997&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70c997",
  null
  
)

export default component.exports